import { Component, h, Prop, State, Listen } from '@stencil/core';

@Component({
  tag: 'qumra-dropdown',
  styleUrl: 'qumra-dropdown.css',
  shadow: true,
})
export class QumraDropdown {
  @Prop() icon: string;
  @State() isOpen: boolean = false;
  private el: HTMLElement; 

  toggleDropdown() {
    this.isOpen = !this.isOpen;

    if (this.isOpen) {
      const openDropdowns = document.querySelectorAll('qumra-dropdown');
      openDropdowns.forEach((dropdown) => {
        const dropdownInstance = dropdown as unknown as QumraDropdown;
        if (dropdownInstance !== this && dropdownInstance.isOpen) {
          dropdownInstance.isOpen = false;
        }
      });
    }
  }

  @Listen('click', { target: 'document' })
  handleClickOutside(event: Event) {
    const path = event.composedPath();
    if (!path.includes(this.el)) {
      this.isOpen = false;
    }
  }

  render() {
    return (
      <div class="qumra-dropdown-container" ref={(el) => (this.el = el)}>
        <div onClick={this.toggleDropdown.bind(this)} innerHTML={this.icon}></div>
        {this.isOpen && (
          <div class="qumra-dropdown-items-container">
              <div>
                <div
                  class="qumra-dropdown-items"
                  style={{ top: '-0.68rem' }}
                ></div>
                <slot></slot>
              </div>
          </div>
        )}
      </div>
    );
  }
}
